module.exports = "/images/inciteBuy.svg";